import { Checkbox } from "primereact/checkbox";
import {
  Controller,
  type FieldValues,
  type Path,
  type UseFormReturn,
} from "react-hook-form";
import { useTranslation } from "react-i18next";

export interface PrivacyAcceptFormData extends FieldValues {
  dataPrivacyNoticeAccepted?: boolean;
}

type PrivacyAcceptProps<T extends PrivacyAcceptFormData> = {
  form: UseFormReturn<T, any, T>;
  required: boolean;
};

export function PrivacyAcceptField<T extends PrivacyAcceptFormData>({
  form,
  required = true,
}: PrivacyAcceptProps<T>) {
  const { t } = useTranslation();

  return (
    <>
      <div className="grid">
        <span className="col-4 hidden md:block"></span>
        <div className="col-12 md:col-8 flex justify-content-start align-items-center gap-1">
          <Controller
            name={"dataPrivacyNoticeAccepted" as Path<T>}
            control={form.control}
            rules={{
              required: required && t("Error.Required"),
            }}
            render={({ field }) => (
              <>
                <Checkbox
                  inputId="privacyAccept"
                  {...field}
                  checked={field.value ?? false}
                  onChange={(e) => field.onChange(e.checked ?? false)}
                />
              </>
            )}
          />
          <div
            className="font-bold text-orange-600"
            dangerouslySetInnerHTML={{
              __html: t("Home.Registration.Accept"),
            }}
          ></div>
        </div>
      </div>
    </>
  );
}
